import { render, staticRenderFns } from "./intellectual.vue?vue&type=template&id=d37a9656&scoped=true&"
import script from "./intellectual.vue?vue&type=script&lang=js&"
export * from "./intellectual.vue?vue&type=script&lang=js&"
import style0 from "./intellectual.vue?vue&type=style&index=0&id=d37a9656&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d37a9656",
  null
  
)

export default component.exports